import httpClient from '@/shared/http-tms-client';

const municipalityMessages = () => httpClient.get('/Municipality/MunicipalittMessages');
const whereToGetPermit = (muniCode) => httpClient.get(`/Municipality/WhereToGetPermit?municode=${muniCode}`);
const postMunicipalityMessage = (data) => httpClient.post('Municipality/MunicipalittMessage', data);
const getOwnerInfo = () => httpClient.get('eservicesowners');
const getMunicipalitiesWithoutMessage = () => httpClient.get('/municipality/MuniWithoutMessage');
const getPermitContacts = () => httpClient.get('eservicesowners/PermitContacts');

export {
  municipalityMessages,
  whereToGetPermit,
  postMunicipalityMessage,
  getOwnerInfo,
  getMunicipalitiesWithoutMessage,
  getPermitContacts,
};
